import { Alert, IconButton, Link, Snackbar } from "@mui/material";
import { useState } from "react";
import { useEnvironmentCheck } from "../../utilities/useEnvironmentCheck";
import { GrFormClose } from "react-icons/gr";

export const EnvironmentAlerts = () => {
    const { showBrowserWarning, showOSWarning, osType, storageKey } = useEnvironmentCheck();

    const [openBrowser, setOpenBrowser] = useState(true);
    const [openOS, setOpenOS] = useState(true);

    const handleHideBrowser = () => {
        localStorage.setItem("hideBrowserWarning", "true");
        setOpenBrowser(false);
    };

    const handleHideOS = () => {
        if (!storageKey) return;

        localStorage.setItem(storageKey, "true");
        setOpenOS(false);
    };

    const alertSx = {
        width: 800,
        alignItems: "center",

        "& .MuiAlert-icon": {
            display: "flex",
            alignItems: "center"
        },

        "& .MuiAlert-message": {
            paddingRight: 2
        },

        "& .MuiAlert-action": {
            display: "flex",
            alignItems: "center",
            margin: 0,
            padding: 0,
            ml: 1
        }
    };

    const hideLinkSx = {
        cursor: "pointer",
        whiteSpace: "nowrap",
        color: "inherit",
        "&:hover": {
            opacity: 0.8
        }
    };

    return (
        <>
            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
                open={showBrowserWarning && openBrowser}
                sx={{ mt: 8 }}
            >
                <Alert
                    severity="info"
                    action={
                        <>
                            <Link
                                component="button"
                                underline="always"
                                onClick={handleHideBrowser}
                                sx={hideLinkSx}
                            >
                                Non mostrare più
                            </Link>

                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={() => setOpenBrowser(false)}
                                sx={{
                                    ml: 2,
                                    p: 0.1
                                }}
                            >
                                <GrFormClose size={20} />
                            </IconButton>
                        </>
                    }
                    sx={alertSx}
                >
                    <>
                        Easyfatt Cloud è ottimizzato per l'utilizzo con <b>Google Chrome</b>.
                        Per un'esperienza più stabile e completa consigliamo di utilizzare Chrome.
                    </>
                </Alert>
            </Snackbar>

            <Snackbar
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right"
                }}
                open={showOSWarning && openOS}
                sx={{
                    mt: showBrowserWarning && openBrowser ? 18 : 8
                }}
            >
                <Alert
                    severity="info"
                    action={
                        <>
                            <Link
                                component="button"
                                underline="always"
                                onClick={handleHideOS}
                                sx={hideLinkSx}
                            >
                                Non mostrare più
                            </Link>
                            <IconButton
                                size="small"
                                color="inherit"
                                onClick={() => setOpenOS(false)}
                                sx={{
                                    ml: 2,
                                    p: 0.1
                                }}
                            >
                                <GrFormClose size={20} />
                            </IconButton>
                        </>                       
                    }
                    sx={alertSx}
                >
                    {osType === "mobile" ? (
                        <>
                            Easyfatt Cloud non è ottimizzato per l’utilizzo su questo tipo di dispositivo.
                        </>
                    ) : osType === "windows_old" ? (
                        <>
                            La versione di Windows in uso non è supportata da Easyfatt Cloud.
                            Per garantire il corretto funzionamento, utilizza <b>Windows 10 o Windows 11</b>.
                        </>
                    ) : (
                        <>
                            Sistema operativo non supportato.
                        </>
                    )}
                </Alert>
            </Snackbar>
        </>
    );
};

